import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import { Link as DSLink } from "@icg360/design-system";

import { CeremonyErrorSection } from "components/ceremony-error-section";
import { CeremonyLink } from "components/ceremony-link/ceremony-link";
import { CeremonyLoginForm } from "components/ceremony-login-form";
import { CeremonyRegistration } from "components/ceremony-registration/ceremony-registration";
import { ExternalHeader } from "components/external-header";
import { LogoImageLink } from "components/shared/logo-link";
import { PageFooter } from "components/shared/page-footer";
import { getCookie, setCookie } from "utils";

import styles from "./ceremony.module.scss";

const Ceremony = () => {
  const navigate = useNavigate();
  const [selectedEmail, setSelectedEmail] = useState("");
  const [emailList, setEmailList] = useState([]);
  const [policyNumber, setPolicyNumber] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [uuid, setUuid] = useState("");
  const [returnUrlParsed, setReturnUrlParsed] = useState(false);

  const formProps = {
    setSelectedEmail,
    emailList,
    policyNumber,
    zipCode,
    firstName,
    lastName,
    uuid,
  };

  useEffect(() => {
    const samlCookie = getCookie("mss-saml-bridge");
    let samlValues = {
      emailList: undefined,
      policyNumber: undefined,
      zipCode: undefined,
      firstName: undefined,
      lastName: undefined,
      uuid: undefined,
    };

    if (samlCookie !== undefined) {
      const jsonString = atob(samlCookie);
      samlValues = JSON.parse(jsonString);
    }

    setCookie(
      "mss-saml-bridge-return",
      btoa(
        JSON.stringify({
          emailList: samlValues.emailList,
          policyNumber: samlValues.policyNumber,
          returnTokenUrl: samlValues.returnTokenUrl,
        }),
      ),
    );

    setReturnUrlParsed(samlValues.returnTokenUrl);
    setEmailList(samlValues.emailList);
    setPolicyNumber(samlValues.policyNumber);
    setZipCode(samlValues.zipCode);
    setFirstName(samlValues.firstName);
    setLastName(samlValues.lastName);
    setUuid(samlValues.uuid);
    if (window.location.pathname === "/ceremony/error") {
      return;
    } else if (samlValues.emailList?.length) {
      navigate("/ceremony/link");
    } else {
      navigate("/ceremony/register");
    }
  }, [navigate]);

  return (
    <>
      <div className={styles.ceremonyWrapper}>
        <div>
          <ExternalHeader returnUrlParsed={returnUrlParsed} />
          <LogoImageLink className={styles.ssLogo} />
          <DSLink
            href={returnUrlParsed?.toString()}
            className={styles.geicoLogo}
          >
            <img src="/assets/images/geico.svg" alt="Geico logo" />
          </DSLink>
          <Routes>
            <Route
              path=""
              element={<Navigate to="/ceremony/register" replace />}
            />
            <Route path="link" element={<CeremonyLink {...formProps} />} />
            <Route
              path="register"
              element={<CeremonyRegistration {...formProps} />}
            />
            <Route
              path="login"
              element={
                <CeremonyLoginForm
                  {...formProps}
                  selectedEmail={selectedEmail}
                />
              }
            />
            <Route path="error" element={<CeremonyErrorSection />} />
          </Routes>
        </div>
      </div>
      <PageFooter unauthenticated />
    </>
  );
};

export default Ceremony;
